{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"__experimental": true,
	"name": "core/table-of-contents",
	"title": "Table of Contents",
	"category": "design",
	"description": "Summarize your post with a list of headings. Add HTML anchors to Heading blocks to link them here.",
	"keywords": [ "document outline", "summary" ],
	"textdomain": "default",
	"attributes": {
		"headings": {
			"type": "array",
			"items": {
				"type": "object"
			},
			"default": [],
			"role": "local"
		},
		"onlyIncludeCurrentPage": {
			"type": "boolean",
			"default": false
		},
		"maxLevel": {
			"type": "number"
		},
		"ordered": {
			"type": "boolean",
			"default": true
		}
	},
	"supports": {
		"anchor": true,
		"ariaLabel": true,
		"html": false,
		"color": {
			"text": true,
			"background": true,
			"gradients": true,
			"link": true
		},
		"spacing": {
			"margin": true,
			"padding": true
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"interactivity": {
			"clientNavigation": true
		},
		"__experimentalBorder": {
			"radius": true,
			"color": true,
			"width": true,
			"style": true,
			"__experimentalDefaultControls": {
				"radius": true,
				"color": true,
				"width": true,
				"style": true
			}
		}
	},
	"style": "wp-block-table-of-contents"
}
